import React from "react";
import InspectionRouter from './Inspection/Router';
export { getFields, getReplyFields } from './Inspection/Router';

export default function InspectionSupervisorRouter(props){
    return <InspectionRouter {...props} mode='PM' />;
}